import * as requestFromServer from './usersClientActionsCrud';
import {usersClientActionsSlice, callTypes} from './usersClientActionsSlice';
import {RequestCancellationManager} from '../../_common/utils/RequestCancellationManager';
import {v4 as guid} from 'uuid';

export const getUsersClientActionsListIDPrefix = 'getUsersClientActionsList';
const {actions} = usersClientActionsSlice;

const getUsersClientActionsList = storeMethod => queryParams => dispatch => {
  dispatch(actions.startCall({callType: callTypes.list}));

  const requestID = `${getUsersClientActionsListIDPrefix}-${guid()}`;
  const cancellationHandlers = RequestCancellationManager.createCancellationHandlers(requestID);

  return requestFromServer
    .getUsersClientActions(queryParams, cancellationHandlers)
    .then(response => {
      const {errorCode, data: {
        totalUsersClientActivitiesCount,
        usersClientActivities,
        pageCount
      }} = response.data;
      if (errorCode !== 0) throw new Error();

      dispatch(storeMethod({
        totalCount: totalUsersClientActivitiesCount,
        pageCount: pageCount,
        entities: usersClientActivities
      }));
    })
    .catch(error => {
      error.clientMessage = 'Can\'t find users actions';
      dispatch(actions.catchError({error, callType: callTypes.list}));
    })
    .finally(() => {
      RequestCancellationManager.forgetRequest(requestID);
    });
};

export const getUsersClientActions = getUsersClientActionsList(actions.usersClientActionsFetched);
export const getNextUsersClientActions = getUsersClientActionsList(actions.usersClientActionsAppended);

export const getUsersClientActivitiesLogsForExcelFile = queryParams => dispatch => {
  dispatch(actions.startCall({callType: callTypes.action}));

  return requestFromServer
    .getUsersClientActivitiesLogsForExcelFile(queryParams)
    .then(response => {
      const {errorCode, data} = response.data;
      if (errorCode !== 0) throw new Error();

      return data;
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'Can\'t get data!';
      dispatch(actions.catchError({error, callType: callTypes.action}));
    });
};